/**
 * Enhances article content by wrapping iframes in responsive containers
 */
document.addEventListener('DOMContentLoaded', () => {
  // Select all iframes within the article content
  const articleContent = document.querySelector('.article-content');
  
  if (articleContent) {
    const iframes = articleContent.querySelectorAll('iframe');
    
    iframes.forEach(iframe => {
      // Check if iframe is not already wrapped
      if (iframe.parentNode.className !== 'article-content__iframe') {
        // Create wrapper div
        const wrapper = document.createElement('div');
        wrapper.className = 'article-content__iframe';
        
        // Get the parent (usually a p tag)
        const parent = iframe.parentNode;
        
        // Replace iframe with wrapper
        parent.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
      }
    });
  }
});